import { createFileRoute, redirect } from "@tanstack/react-router";
import { OrgMembersPage } from "@/components/org";

export const Route = createFileRoute("/org")({
  // Require auth + org_admin/admin role (spec §15.9). isLoading guard
  // avoids redirecting during the AuthProvider's initial bootstrap.
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) return;
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: "/login", search: { redirect: "/org" } });
    }
    const role = context.auth.user?.role;
    if (role !== "org_admin" && role !== "admin") {
      throw redirect({ to: "/" });
    }
  },
  component: OrgMembersPage,
});
